import React from "react";
import styled from "styled-components";

//
import alex from "../../../../../assets/images/alex.webp";

export default function Review() {
  return (
    <StyledReview className="reviews_section">
      <div className="container">
        <h2 className="section_title">Отзывы</h2>
        <div className="reviews_row">
          <div className="reviews_item">
            <div className="reviews_item_head">
              <div className="reviews_item_img">
                <img width="50" height="50" src={alex} alt="alex" />
              </div>
              <div className="reviews_item_user">
                <div className="reviews_item_name">Александр Авдошкин</div>
                <div className="reviews_item_spec">
                  Инженер технической поддержки
                </div>
              </div>
            </div>
            <div className="reviews_item_body">
              "Если бы не коронавирус, выполнил бы всё в заход (в смысле каждый
              день по несколько пунктов в теме). Изучаю с нуля, ваш портал очень
              ориентирован на новичков. Спасибо вам большое!"
            </div>
          </div>
          <div className="reviews_item">
            <div className="reviews_item_head">
              <div className="reviews_item_img">
                <img width="50" height="50" src={alex} alt="alex" />
              </div>
              <div className="reviews_item_user">
                <div className="reviews_item_name">Александр Авдошкин</div>
                <div className="reviews_item_spec">
                  Инженер технической поддержки
                </div>
              </div>
            </div>
            <div className="reviews_item_body">
              "Если бы не коронавирус, выполнил бы всё в заход (в смысле каждый
              день по несколько пунктов в теме). Изучаю с нуля, ваш портал очень
              ориентирован на новичков. Спасибо вам большое!"
            </div>
          </div>
          <div className="reviews_item">
            <div className="reviews_item_head">
              <div className="reviews_item_img">
                <img width="50" height="50" src={alex} alt="alex" />
              </div>
              <div className="reviews_item_user">
                <div className="reviews_item_name">Александр Авдошкин</div>
                <div className="reviews_item_spec">
                  Инженер технической поддержки
                </div>
              </div>
            </div>
            <div className="reviews_item_body">
              "Если бы не коронавирус, выполнил бы всё в заход (в смысле каждый
              день по несколько пунктов в теме). Изучаю с нуля, ваш портал очень
              ориентирован на новичков. Спасибо вам большое!"
            </div>
          </div>
        </div>
      </div>
    </StyledReview>
  );
}

const StyledReview = styled.div`
  &.reviews_section {
    margin-top: 96px;
  }
  .reviews_row {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-gap: 24px;
    margin-top: 48px;
  }
  .reviews_item_head {
    display: flex;
    align-items: center;
    margin-bottom: 16px;
  }
  .reviews_item_name {
    font-weight: bold;
  }
  .reviews_item_body {
    font-style: italic;
    line-height: 1.5;
  }
  .reviews_item_img {
    border-radius: 100%;
    overflow: hidden;
    margin-right: 16px;
  }

  @media (max-width: 991px) {
    .reviews_row {
      grid-template-columns: repeat(2, 1fr);
    }
  }
  @media (max-width: 576px) {
    .reviews_row {
      grid-template-columns: 1fr;
    }
  }
`;
